import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";

import theme from "assets/theme-dark";
import { isAuth } from "Helpers/AuthHelpers";
import SignIn from "./Auth/Signin";
import Main from "./Main/Main";

export default function App() {
  return (
    <BrowserRouter>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {isAuth ? (
          <>
            <Routes>
              <Route path="/" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            <Main />
          </>
        ) : (
          <Routes>
            <Route path="*" element={<Navigate to="/signin" replace />} />
            <Route path="/signin" element={<SignIn />} />
          </Routes>
        )}
      </ThemeProvider>
    </BrowserRouter>
  );
}
